<div
  class="search-area-container {{ className }}"
  [ngClass]="{ active: active }"
  appClickOutside
  (clickOutside)="close()"
>
  <input
    *ngIf="active"
    id="searchValue"
    placeholder="Search"
    type="text"
    class="{{
      className.includes('w-')
        ? '  w-full ' + className
        : ' max-w-[150px] search-input'
    }} lg px-[10px]"
    [(ngModel)]="searchInput"
    (keyup.enter)="setActive()"
  />
  <input
    id="searchValue"
    placeholder="Search"
    type="text"
    class="{{
      className.includes('w-')
        ? '  w-full ' + className
        : ' max-w-[150px] search-input'
    }} mobile"
    [(ngModel)]="searchInput"
  />
  <div class="helper" (click)="setActive()">
    <img
      (click)="setActive()"
      class="search-icon"
      src="../../../assets/icons/search.svg"
      alt=""
    />
    <span *ngIf="!active" class="placeholder">Search</span>
  </div>
</div>

